
const Config = {
    apiUrl: 'https://joplin.control-room.dev',
    categories : ['Magic','Movie','AdultVideo','Animation','TV Show','Unknown']
};



export default Config;

